var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form",
            { attrs: { slot: "detail", form: _vm.form }, slot: "detail" },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "租户编号",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input-number", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "id",
                                  {
                                    rules: [
                                      {
                                        required: true,
                                        message: "请输入租户编号",
                                      },
                                    ],
                                  },
                                ],
                                expression:
                                  "['id', { rules: [{ required: true, message: '请输入租户编号' }] }]",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: { min: 1, placeholder: "请输入租户编号" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "租户名称",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["name"],
                                expression: "['name']",
                              },
                            ],
                            attrs: { placeholder: "请输入租户名称" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  Object.keys(this.model).length
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "推送提醒日期",
                                    labelCol: {
                                      xs: { span: 24 },
                                      sm: { span: 10 },
                                    },
                                    wrapperCol: {
                                      xs: { span: 24 },
                                      sm: { span: 14 },
                                    },
                                  },
                                },
                                [
                                  _c("j-dict-select-tag", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      "dict-code": "dayOfWeekAll",
                                      placeholder: "请选择推送提醒日期",
                                    },
                                    model: {
                                      value: _vm.model.dayOfWeekWarn,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "dayOfWeekWarn",
                                          $$v
                                        )
                                      },
                                      expression: "model.dayOfWeekWarn",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "提醒时间",
                                    labelCol: {
                                      xs: { span: 24 },
                                      sm: { span: 6 },
                                    },
                                    wrapperCol: {
                                      xs: { span: 24 },
                                      sm: { span: 12 },
                                    },
                                  },
                                },
                                [
                                  _c("a-time-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: { format: "HH:mm" },
                                    model: {
                                      value: _vm.model.pushTime,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.model, "pushTime", $$v)
                                      },
                                      expression: "model.pushTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  Object.keys(this.model).length
                    ? _c(
                        "a-col",
                        { staticClass: "aCol", attrs: { span: 24 } },
                        [
                          _c("span", { staticClass: "spanCol" }, [_vm._v("*")]),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "选择预警模型",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("j-dict-select-tag", {
                                key: _vm.model.id,
                                staticStyle: { width: "100%" },
                                attrs: {
                                  isShowEmpty: false,
                                  "dict-code": "push_model",
                                  allowClear: false,
                                  placeholder: "请选择预警模型",
                                },
                                model: {
                                  value: _vm.model.pushModel,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "pushModel", $$v)
                                  },
                                  expression: "model.pushModel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "经度",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input-number", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["lng"],
                                expression: "['lng']",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入经度" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "纬度",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input-number", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["lat"],
                                expression: "['lat']",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入纬度" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "appKey",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["appKey"],
                                expression: "['appKey']",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入appKey" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "appSecret",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["appSecret"],
                                expression: "['appSecret']",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入appSecret" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "corpId",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["corpId"],
                                expression: "['corpId']",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入corpId" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "agentId",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["agentId"],
                                expression: "['agentId']",
                              },
                            ],
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入agentId" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "照片",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("j-image-upload", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["pic"],
                                expression: "['pic']",
                              },
                            ],
                            attrs: { bizPath: "studentFace" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "状态",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c(
                            "a-radio-group",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["status", { initialValue: 1 }],
                                  expression: "['status', { initialValue: 1 }]",
                                },
                              ],
                              attrs: { name: "tenantStatus" },
                            },
                            [
                              _c("a-radio", { attrs: { value: 1 } }, [
                                _vm._v("正常"),
                              ]),
                              _c("a-radio", { attrs: { value: 0 } }, [
                                _vm._v("冻结"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "机构",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              placeholder: "请选择机构",
                              dictCode: "school_org,name,id",
                            },
                            model: {
                              value: _vm.model.orgId,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "orgId", $$v)
                              },
                              expression: "model.orgId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showFlowSubmitButton
                    ? _c(
                        "a-col",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { span: 24 },
                        },
                        [
                          _c("a-button", { on: { click: _vm.submitForm } }, [
                            _vm._v("提 交"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }